import { render, staticRenderFns } from "./EsqueciSenhaInterno.vue?vue&type=template&id=9fd776a0"
import script from "./EsqueciSenhaInterno.vue?vue&type=script&lang=js"
export * from "./EsqueciSenhaInterno.vue?vue&type=script&lang=js"
import style0 from "./EsqueciSenhaInterno.vue?vue&type=style&index=0&id=9fd776a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports